import { render, staticRenderFns } from "./ModalHistoricoMensageria.vue?vue&type=template&id=9f287e50"
import script from "./ModalHistoricoMensageria.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoMensageria.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoMensageria.vue?vue&type=style&index=0&id=9f287e50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports